import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { ATTENTION_DASHBOARD_CRUD_ACTION_CREATORS } from '../actions/attention_dashboard_actions';
import { nullSafeGetOrElse } from '../utils/DataAccessUtils';
import { setDefaultView } from '../actions/session_actions';

export const attentionDashboardsRestCrudThunksForBuyer = new RestCrudThunks(
	'attention_dashboards',
	'attention_dashboard',
	'attentinoDashboard',
	'attentionDashboards',
	ATTENTION_DASHBOARD_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'dashboard/'
);

export const attentionDashboardsRestCrudThunksForSupplier = new RestCrudThunks(
	'attention_dashboards',
	'attention_dashboard',
	'attentinoDashboard',
	'attentionDashboards',
	ATTENTION_DASHBOARD_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'dashboard/'
);

export const getAttentionDashboard = (dispatch, userType) => {
	return new Promise((resolve, reject) => {
		dispatch(
			userType === ROLE_TYPES.SUPPLIER
				? attentionDashboardsRestCrudThunksForSupplier.readOne('default')
				: attentionDashboardsRestCrudThunksForBuyer.readOne('default')
		)
			.then((data) => {
				dispatch(setDefaultView(nullSafeGetOrElse('defaultWorkOrderFilterView', data, {})));
				resolve(data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};

export const updateAttentionDashboard = (dispatch, userType, entity) => {
	return new Promise((resolve, reject) => {
		dispatch(
			userType === ROLE_TYPES.SUPPLIER
				? attentionDashboardsRestCrudThunksForSupplier.update(entity)
				: attentionDashboardsRestCrudThunksForBuyer.update(entity)
		)
			.then((data) => {
				dispatch(setDefaultView(nullSafeGetOrElse('defaultWorkOrderFilterView', data, {})));
				resolve(data);
			})
			.catch((err) => {
				reject(err);
			});
	});
};
